// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DndContext, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';

// Internal Dependencies
import GridList from './gridList';
import { IsEmpty } from '../../../common/checks';

const useStyles = makeStyles((theme) => ({
  sort: {
    zIndex: 1000000,
    cursor: 'grabbing',
  },
  paper: {
    padding:   theme.spacing(1),
    textAlign: 'center',
    color:     theme.palette.text.secondary,
  },
}));

const HeaderTitle = 'Display First In App';
const FooterTitle = 'Display Last In App';

const Sortable = ({ ads, handleSort }) => {
  const classes = useStyles();
  const sensors = useSensors(
    useSensor(TouchSensor),
    useSensor(MouseSensor),
  );

  const [items, setItems] = React.useState(ads);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (IsEmpty(active) || IsEmpty(over)) {
      return;
    }

    if (active.id !== over.id) {
      setItems((_items) => {
        const oldIndex = _items.findIndex((item) => item.id === active.id);
        const newIndex = _items.findIndex((item) => item.id === over.id);

        const sorted = arrayMove(_items, oldIndex, newIndex);
        const formattedAds = _.map(_.cloneDeep(sorted), (ad, index) => ({ ...ad, displayOrder: index + 1 }));

        handleSort(formattedAds);

        return formattedAds;
      });
    }
  };

  return (
    <>
      <Grid container item sm={12}>
        <Grid item xs={12}>
          <Paper className={classes.paper} elevation={0}>
            <Typography variant="subtitle2">{HeaderTitle.toUpperCase()}</Typography>
          </Paper>
        </Grid>
      </Grid>
      <hr />

      <DndContext onDragEnd={handleDragEnd} sensors={sensors} modifiers={[restrictToVerticalAxis]}>
        <SortableContext
          items={items}
          strategy={verticalListSortingStrategy}
        >
          <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
            {items.map((value) => (
              <div key={value.id} className={classes.sort}>
                <GridList value={value} />
              </div>
            ))}
          </div>
        </SortableContext>
      </DndContext>

      <hr />
      <Grid container item sm={12}>
        <Grid item xs={12}>
          <center>
            <Paper className={classes.paper} elevation={0}>
              <Typography variant="subtitle2">{FooterTitle.toUpperCase()}</Typography>
            </Paper>
          </center>
        </Grid>
      </Grid>
    </>
  );
};

export default Sortable;

Sortable.propTypes = {
  ads:        PropTypes.arrayOf(PropTypes.shape(Object)),
  handleSort: PropTypes.func,
};

Sortable.defaultProps = {
  ads:        [],
  handleSort: () => {},
};
